import type { StatusVariant } from '@/design/components'
import type { CaseMemberRole, CasePartyKind, CaseStatus } from './types'

/**
 * Etykiety i warianty chipów statusu sprawy.
 *
 * Warianty biorę z komentarzy w `src/design/components/StatusChip.tsx` (własność
 * frontend-core), gdzie autor tokenów przypisał kolory dokładnie do tych etykiet —
 * dzięki temu chipy wyglądają jak na `design/screens/screen-rejestr-spraw.png`.
 */
export const STATUS_LABEL: Record<CaseStatus, string> = {
  w_toku: 'W toku',
  oczekuje_na_termin: 'Oczekuje na termin',
  zawieszona: 'Zawieszona',
  zakonczona: 'Zakończona',
  doradztwo: 'Doradztwo',
}

export const STATUS_VARIANT: Record<CaseStatus, StatusVariant> = {
  w_toku: 'info',
  oczekuje_na_termin: 'warning',
  zawieszona: 'neutral',
  zakonczona: 'success',
  doradztwo: 'neutral',
}

export const STATUS_OPTIONS = (Object.keys(STATUS_LABEL) as CaseStatus[]).map((value) => ({
  value,
  label: STATUS_LABEL[value],
}))

export const ROLE_LABEL: Record<CaseMemberRole, string> = {
  prowadzacy: 'Prawnik prowadzący',
  nadzorujacy: 'Partner nadzorujący',
  associate: 'Associate',
  paralegal: 'Paralegal',
}

export const PARTY_LABEL: Record<CasePartyKind, string> = {
  powod: 'Powód — klient kancelarii',
  pozwany: 'Pozwany',
  klient: 'Klient kancelarii',
  przeciwnik: 'Strona przeciwna',
  inna: 'Inna strona',
}

/** Rodzaje spraw akceptowane przez backend (`CASE_KINDS` w models.py). */
export const CASE_KINDS = [
  'cywilna',
  'gospodarcza',
  'pracownicza',
  'administracyjna',
  'windykacja',
  'odwolawcza',
  'doradztwo',
] as const

export const KIND_LABEL: Record<string, string> = {
  cywilna: 'Cywilna',
  gospodarcza: 'Gospodarcza',
  pracownicza: 'Pracownicza',
  administracyjna: 'Administracyjna',
  windykacja: 'Windykacja',
  odwolawcza: 'Odwoławcza',
  doradztwo: 'Doradztwo',
}

export function kindLabel(kind: string | null | undefined): string {
  if (!kind) return '—'
  return KIND_LABEL[kind] ?? kind.charAt(0).toUpperCase() + kind.slice(1)
}
